<template>
  <downloadexcel
    class="btn"
    :fetch="fetchData"
    :fields="json_fields"
    :before-generate="startDownload"
    :before-finish="finishDownload"
    :name="reportName"
  >
    <button type="button" class="btn btn-primary" :disabled="loading">
      Generate<i class="fa fa-lg fa-file-excel ml-2 text-success" />
      <span
        v-if="loading"
        class="spinner-grow spinner-grow-sm text-light"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </span>
    </button>
  </downloadexcel>
</template>

<script>
import downloadexcel from "vue-json-excel";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "ToExcel",
  components: {
    downloadexcel,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: () => "sales",
    },
  },
  data() {
    return {
      loading: false,
      json_fields: {
        "Client Name": "clientName",
        Gender: "sex",
        Age: "age",
        ID: "clientID",
        Province: "province",
        District: "district",
        Sector: "sector",
        Cell: "cell",
        Village: "village",
        "Phone Number": "phoneNumber",
        Items: {
          field: "items",
          callback: (items) =>
            items.reduce((prev, current, index) => {
              return `${prev}- Item ${index + 1}: ${current.name} Unit Price: ${
                current.price
              } Rwf Quantity: ${current.quantity} Description: ${
                current.description
              }\n`;
            }, ""),
        },
        "Total Items": {
          field: "items",
          callback: (items) => items.length,
        },
        "Total Cost (Rwf)": {
          field: "items",
          callback: (items) => {
            const sum = items.reduce(
              (prev, current) => (prev += current.price),
              0
            );
            return sum.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          },
        },
        Agent: "user.name",
        "Agent Phone": "user.phoneNumber",
        Company: "company.name",
        "Last Edidate At": "updatedAt",
        "Created At": "createdAt",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapGetters({
      token: "auth/token",
    }),
    reportName() {
      return `${this.name}-report.xls`;
    },
  },
  methods: {
    async fetchData() {
      const response = await axios.get(this.url, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      });
      const { rows } = response.data;
      return rows;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },
  },
};
</script>
